export default __webpack_public_path__ + "static/events-dark-4efb4908a327fee2da0b831995f79bdf.png";